import { setDefaultOptions } from 'date-fns';

import { DateFnsLocaleMapper } from 'shared/constants/dates';

import type { Locale } from 'date-fns';
import type { FnsLocale } from 'shared/types/fnsLocale';

const getFnsLocale = async (locale: string): Promise<Locale> =>
  import(
    /* webpackExclude: /_lib/, webpackMode: "lazy", webpackChunkName: "df-[index]" */ `date-fns/locale/${locale}/index.js`
  );

export const setDateFnsLocale = async (lng: string) => {
  const fnsLocale = DateFnsLocaleMapper[lng as FnsLocale];
  const locale = await getFnsLocale(fnsLocale);

  setDefaultOptions({ locale });
};
